import { Component, Inject, PLATFORM_ID } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { MessagingService } from './services/messaging.service';
import { DataSharingService } from './services/data.share.service';
import { isPlatformBrowser } from "@angular/common";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "TaxCanary";
  message:any;
  private platformId: any;
  constructor(private router: Router,  private dataSharingService: DataSharingService, private messagingService: MessagingService, @Inject(PLATFORM_ID) platformId: Object, config: NgbDropdownConfig) {
    config.container = 'body';
    this.platformId = platformId;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)){ 
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  ngOnInit() {
    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage;
    // console.log('this message', this.message)
  }


  

}
